<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @searchFn="searchFn"
        @confirmFn="getListFn"
        @nodeClick="nodeClick"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @reuseUseFn="reuseUseFn"
        @calibrationFn="calibrationFn"
        @calibrationImportFn="calibrationImportFn"
        @calibrationExpiredFn="calibrationExpiredFn"
      />
      <div class="componentPage">
        <stop-table
          :loading="loading"
          ref="table"
          :tableData="tableData"
          @choozeTable="choozeTable"
          @detailFn="detailFn"
          @delRowFn="delRowFn"
          @refreshFn="refreshFn"
          @editScopeRowFn="editScopeRowFn"
          @calibrationSignleFn="calibrationSignleFn"
        />

        <Pager
          ref="pager"
          :total="total"
          :size="SearchForm.iDisplayLength"
          @currentChange="getListFn"
        ></Pager>
      </div>
    </div>

    <!-- 网络参数上报规则模态框  -->
    <v-net
      :isShow.sync="isShow"
      :choozeTableData="choozeTableData"
      :useFuncType="useFuncType"
      ref="vForm"
    />
    <!-- 修改范围 -->
    <v-scope
      :isShowConfig.sync="isShowScope"
      :scopeArray="scopeArray"
      ref="scopedId"
    ></v-scope>
    <!-- 详情 -->
    <!-- <v-detail
      ref="detail"
      :isShowDetail.sync="detailIsShow"
      :title="detailTitle"
      :baseMsg="baseMsg"
      :detailObj="detailObj"
      :newDeviceType="newDeviceType"
      :deviceProperty="deviceProperty"
      :detailLoading="detailLoading"
      :detailRuleObj="detailRuleObj"
      :detailNetObj="detailNetObj"
      :sensorWay="sensorWay"
      @changdetail="changdetail"
    /> -->

    <MagnetismDetailDialog></MagnetismDetailDialog>
    <!-- 校准模态框 -->
    <CalibrationDialog
      v-if="isShowCalibration"
      :isShow.sync="isShowCalibration"
      :choozeTableData="choozeTableData"
      :rowData="rowData"
      :singleCalibration="singleCalibration"
      :devType="6"
    >
    </CalibrationDialog>
    <!-- 标准导入模态框 -->
    <CalibrationImport
      :isShow.sync="isShowCaliImport"
      :choozeTableData="choozeTableData"
    >
    </CalibrationImport>
    <!-- 标准过期模态框 -->
    <CalibrationExpired
      v-if="isShowCaliExpired"
      :isShow.sync="isShowCaliExpired"
      :deviceCatalog="6"
    >
    </CalibrationExpired>
  </div>
</template>

<script>
import { deleteMagnetism, deleteMagnetismBatch, magnetismStatusUse, magnetismList} from '@/api/modules/sensor.js'
import { shareScope } from '@/api/modules/public.js'

import netParam from '../components/NetParam.vue'
import ConfigDialogVue from '../components/ConfigDialog.vue'
import StopTable from './StopTable.vue'
import editScope from '../components/EditScope.vue'
// import detailDialog from '../DetailDialog.vue'

import qs from 'qs'
import bus from '@/utils/bus.js'
import formMixin from '@/utils/formMixins.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import MagnetismDetailDialog from '@/components/dialog/magnetismDetail/magnetismDetailDialog.vue'
import Pager from '@/components/Pagination/src/Pager.vue'
import CalibrationDialog from '@/pages/equipment/sensor/components/sensor/CalibrationDialog.vue'
import CalibrationImport from '@/pages/equipment/sensor/components/sensor/CalibrationImport.vue'
import CalibrationExpired from '@/pages/equipment/sensor/components/sensor/CalibrationExpired.vue'

export default {
  name: 'bindTalbe',
  components: {
    Pager,
    'v-net': netParam,
    'v-config': ConfigDialogVue,

    'stop-table': StopTable,

    'v-scope': editScope,
    // 'v-detail': detailDialog,
    MagnetismDetailDialog,
    CalibrationDialog,
    CalibrationImport,
    CalibrationExpired
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  computed: {
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    }
  },

  mixins: [formMixin, getAllTreePath],
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'public.table_code',
          type: 'input',
          paramsName: 'magnetismCode',
          isChooze: true
        },
        {
          id: 4,
          text: 'integration.magnetism_type',
          type: 'select',
          paramsName: 'type',
          isChooze: false,
          selectParam: []
        },
        {
          id: 2,
          text: 'public.carrier',
          type: 'input',
          paramsName: 'carrierName',
          isChooze: false
        },
        {
          id: 3,
          text: 'device.forward_gateway',
          type: 'input',
          paramsName: 'gatewayName',
          isChooze: false
        }
      ],
      SearchForm: {
        magnetismCode: null,
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        gatewayName: null,
        type: null,
        carrierName: null,
        sceneId: null,
        scopeId: null,
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        {
          id: 4,
          icon: '',
          vHas: ['incubatorDelCarrier'],
          text: 'device.reuse',
          method: 'reuseUseFn'
        },
        {
          id: 5,
          icon: '',
          vHas: ['incubatorDelCarrier'],
          text: 'device.modify_customer',
          method: 'editScopeFn'
        }
      ],
      sensorWay: 'stop',
      // 勾选的表格数据
      choozeTableData: [],
      // 网络参数模态框
      isShow: false,
      // 区分六种情况下的表单
      useFuncType: '',
      // 配置模态框
      isShowConfig: false,
      configContent: {},
      rowData: null,
      // 点击表格的数据

      // 未确认
      isShowUnDialog: false,
      unTitle: '',
      // 修改范围
      isShowScope: false,
      scopeArray: [],
      // 详情
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        {
          text: 'public.carrier',
          key: 'carrierName',
          content: ''
        },
        {
          text: 'device.sensor_code',
          key: 'tagId',
          content: ''
        },
        {
          text: 'device.sensor_type',
          key: 'type',
          content: ''
        },

        {
          text: 'device.sensor_status',
          key: 'status',
          content: ''
        },
        // {
        //   text: 'device.config_status',
        //   key: 'config_status',
        //   content:''
        // },
        // {
        //   text: 'public.table_create_time',
        //   key: 'create_time',
        //   content:''
        // },
        {
          text: 'device.stop_time',
          key: 'stop_time',
          content: ''
        },
        {
          key: 'nickname',
          text: 'device.nickname',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        }
      ],
      detailIsShow: false,
      detailTitle: '',
      // 传感器的基础信息
      detailObj: {},
      // 属性的健名
      newDeviceType: {},
      // 属性的对应值
      deviceProperty: {},
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: 'device.sample_interval',
          isBool: true
        },
        {
          key: 'exCollectInterval',
          text: 'device.exception_sample_interval',
          isBool: true
        },
        {
          key: 'tempCollectInterval',
          text: $t('integration.temperature_acquisition_interval'),
          isBool: true
        },
        {
          key: 'tempChange',
          text: $t('integration.temperature_change_threshold'),
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: $t('integration.maximum_temperature_reporting_interval'),
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: $t('integration.minimum_temperature_reporting_interval'),
          isBool: true
        },

        {
          key: 'humCollectInterval',
          text: $t('integration.humidity_collection_interval'),
          isBool: true
        },
        {
          key: 'humChange',
          text: $t('integration.humidity_change_threshold'),
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: $t('integration.maximum_humidity_reporting_interval'),
          isBool: true
        },
        {
          key: 'humMinReport',
          text: $t('integration.humidity_minimum_reporting_interval'),
          isBool: true
        }
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailLoading: false,

      isShowCalibration: false,
      isShowCaliImport: false,
      isShowCaliExpired: false,
      singleCalibration: false
    }
  },
  mounted () {
    if (this.sysAdmin === 'noSysIsAdmin' || this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.pop()
    }
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.splice(1, 2)
    }
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
         this.SearchForm.scopeId = row.scopeId
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.scopeId = null
        this.SearchForm.sceneId = row.sceneId
      }

      this.getListFn()
    })
  },
  methods: {
    searchFn () {
      this.$refs.pager.reset()
      this.SearchForm.iDisplayStart = 0
      this.getListFn()
    },
    /** 分页 */
    getListFn ({ iDisplayStart, iDisplayLength } = {}) {
      if (iDisplayLength) {
        this.SearchForm.iDisplayStart = iDisplayStart
        this.SearchForm.iDisplayLength = iDisplayLength
      }
      this.loading = true

      magnetismList(this.SearchForm, this.sensorWay)
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 重置 */
    resetFn () {
      this.SearchForm = {
        magnetismCode: null,
        scopeName:
          this.$store.state.SchemaTree[0].sceneCode === 'all_node'
            ? null
            : this.$store.state.SchemaTree[0].label,
        sceneId: null,
        scopeId: null,
        gatewayName: null,
        type: null,
        configurate: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      this.treePathObj =
        this.$store.state.SchemaTree[0].scene_code === 'all_node'
          ? null
          : this.$store.state.SchemaTree[0].label
      this.getListFn()
    },
    /** 特殊处理 */
    nodeClick (option) {
      for (const key in this.SearchForm) {
        if (key === 'undefined') {
          delete this.SearchForm[key]
        }
      }
      this.SearchForm.sceneId = option.label.sceneId
      // this.$set(this.SearchForm,'sceneId',option.label.scene_id);
    },
    /** 网络参数& 上报规则 */
    netFn (row) {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.useFuncType = this.choozeTableData[0].type
      this.isShow = true

      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        // 将dioForm数据init
        const OBJ = this.$refs.vForm.dioForm
        for (const key in OBJ) {
          this.$set(OBJ, key, null)
        }
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },

    choozeTable (row) {
      this.choozeTableData = row
    },

    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情跳转 */
    detailFn (row) {
      bus.$emit('magnetismParam', row.id, row.magnetismCode)
    },
    /** 删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          const ids = this.choozeTableData.map(item => item.id)
          deleteMagnetismBatch(1, ids).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          deleteMagnetism(1, row.id ).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条重新使用 */
    refreshFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          magnetismStatusUse('use', [row.id]).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 多条 */
    reuseUseFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          magnetismStatusUse('use',idList).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 获取范围 */
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    // 修改范围
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('sceneId')
      if (!flag) {
        return this.$message.error(
          $t('integration.the_selected_sensor_is_not_the_same_customer')
        )
      }
      this.isShowScope = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = this.choozeTableData[0].sceneId
        this.$refs.scopedId.dioForm.ids = this.choozeTableData.map(item => item.id)
      })
    },
    // 单条修改范围
    editScopeRowFn (row) {
      this.isShowScope = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId = row.sceneId
        this.$refs.scopedId.dioForm.ids = [row.id]
      })
    },
    // 校准
    calibrationFn(){
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShowCalibration = true
      this.singleCalibration = false
    },
    calibrationImportFn(){
      this.isShowCaliImport = true
    },
    calibrationExpiredFn(){
      this.isShowCaliExpired = true
    },
    // 单条校准
    calibrationSignleFn(row){
      this.isShowCalibration = true
      this.rowData = { ...row }
      this.singleCalibration = true
    }
  }
}
</script>
<style lang="scss" scoped>
.bindPage {
  width: 100%;
  padding-right: 15px;
  box-sizing: border-box;

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
